module.exports = require('./helpers/bundle-url').getBundleURL('1g72z') + "logo-dark.eefe0b7f.svg";